import React from "react";
import "./Marquee.css";
import amyraa from "../../../Assets/Images/OurClientsline/Group 18155.webp";
import asianpaints from "../../../Assets/Images/OurClientsline/Group 678.webp";
import gptw from "../../../Assets/Images/OurClientsline/image 51.webp";
import oren from "../../../Assets/Images/OurClientsline/image 75.webp";
import fikka from "../../../Assets/Images/OurClientsline/image 76.webp";
import jags from "../../../Assets/Images/OurClientsline/image 211.webp";
import anglealign from "../../../Assets/Images/OurClientsline/image 78.webp";
import generalmanagerinstitute from "../../../Assets/Images/OurClientsline/image 210.webp";
import greenstar from "../../../Assets/Images/OurClientsline/image 194.webp";
import goodrej from "../../../Assets/Images/OurClientsline/image 188.webp";
import ShillsProfessional from "../../../Assets/Images/OurClientsline/image 156.webp";
import Karnawat from "../../../Assets/Images/OurClientsline/image 209.webp";
import Genwe from "../../../Assets/Images/OurClientsline/image 77.webp";
import MissionToCure from "../../../Assets/Images/OurClientsline/image 104.webp";
import MansaMataFinance from "../../../Assets/Images/OurClientsline/image 212.webp";
import Veekay from "../../../Assets/Images/OurClientsline/Group 1272628337.webp";
import Faatang from "../../../Assets/Images/OurClientsline/image 163.webp";
import SpProduct from "../../../Assets/Images/OurClientsline/image 129.webp";
import Keynote from "../../../Assets/Images/OurClientsline/image 148.webp";
import Vivaah from "../../../Assets/Images/OurClientsline/image 199.webp";
import Poker from "../../../Assets/Images/OurClientsline/image 173.webp";
import Greenlight from "../../../Assets/Images/OurClientsline/image 165.webp";
import Oleo from "../../../Assets/Images/OurClientsline/image 185.webp";
import SnekaerVally from "../../../Assets/Images/OurClientsline/Group 1272628338.webp";
import Snergy from "../../../Assets/Images/OurClientsline/image 184.webp";
import forumhardware from "../../../Assets/Images/OurClientsline/image 152.webp";
import Terraglow from "../../../Assets/Images/OurClientsline/Group 18391.webp";
import Centerac from "../../../Assets/Images/OurClientsline/image 170.webp";
import Kcl from "../../../Assets/Images/OurClientsline/image 176.webp";
import Jcc from "../../../Assets/Images/OurClientsline/jcc LOGO 2.webp";
import HelloJweller from "../../../Assets/Images/OurClientsline/Group 3666.webp";
import Greengati from "../../../Assets/Images/OurClientsline/image 135.webp";
import NeoCell from "../../../Assets/Images/OurClientsline/Group 3733.webp";
import PrimeJewller from "../../../Assets/Images/OurClientsline/Group 3654.webp";

function Marquee() {
  return (
    <div>
      <div className="marquee">
        <ul className="marquee__content scrollWala">
          <li>
            <img src={amyraa} alt="" width="80%" />
          </li>
          <li>
            <img src={asianpaints} alt="" width="70%" />
          </li>
          <li>
            <img src={gptw} alt="" width="80%" />
          </li>
          <li>
            <img src={oren} alt="" width="80%" />
          </li>
          <li>
            <img src={fikka} alt="" width="80%" />
          </li>
          <li>
            <img src={anglealign} alt="" width="80%" />
          </li>
          <li>
            <img src={generalmanagerinstitute} alt="" width="80%" />
          </li>
          <li>
            <img src={greenstar} alt="" width="80%" />
          </li>
          <li>
            <img src={goodrej} alt="" width="100%" />
          </li>
          <li>
            <img src={jags} alt="" width="80%" />
          </li>
          <li>
            <img src={ShillsProfessional} alt="" width="80%" />
          </li>
          <li>
            <img src={Karnawat} alt="" width="80%" />
          </li>
          <li>
            <img src={Genwe} alt="" width="80%" />
          </li>
          <li>
            <img src={MissionToCure} alt="" width="80%" />
          </li>
          <li>
            <img src={MansaMataFinance} alt="" width="80%" />
          </li>
          <li>
            <img src={Veekay} alt="" width="80%" />
          </li>
          <li>
            <img src={Faatang} alt="" width="80%" />
          </li>
          <li>
            <img src={SpProduct} alt="" width="80%" />
          </li>
          <li>
            <img src={Keynote} alt="" width="100%" />
          </li>
          <li>
            <img src={Vivaah} alt="" width="80%" />
          </li>
          <li>
            <img src={Poker} alt="" width="90%" />
          </li>
          <li>
            <img src={Greenlight} alt="" width="90%" />
          </li>
          <li>
            <img src={Oleo} alt="" width="90%" />
          </li>
          <li>
            <img src={SnekaerVally} alt="" width="90%" />
          </li>
          <li>
            <img src={Terraglow} alt="" width="90%" />
          </li>
          <li>
            <img src={forumhardware} alt="" width="90%" />
          </li>
          <li>
            <img src={Snergy} alt="" width="90%" />
          </li>
          <li>
            <img src={Centerac} alt="" width="90%" />
          </li>
          <li>
            <img src={Kcl} alt="" width="90%" />
          </li>

          <li>
            <img src={Jcc} alt="" width="90%" />
          </li>

          <li>
            <img src={HelloJweller} alt="" width="90%" />
          </li>

          <li>
            <img src={Greengati} alt="" width="90%" />
          </li>
          <li>
            <img src={NeoCell} alt="" width="90%" />
          </li>

          {/* <li>
            <img src={PrimeJewller} alt="" width="90%"  />
          </li> */}
        </ul>
        <ul className="marquee__content scrollWala">
          <li>
            <img src={amyraa} alt="" width="80%" />
          </li>
          <li>
            <img src={asianpaints} alt="" width="70%" />
          </li>
          <li>
            <img src={gptw} alt="" width="80%" />
          </li>
          <li>
            <img src={oren} alt="" width="80%" />
          </li>
          <li>
            <img src={fikka} alt="" width="80%" />
          </li>
          <li>
            <img src={anglealign} alt="" width="80%" />
          </li>
          <li>
            <img src={generalmanagerinstitute} alt="" width="80%" />
          </li>
          <li>
            <img src={greenstar} alt="" width="80%" />
          </li>
          <li>
            <img src={goodrej} alt="" width="100%" />
          </li>
          <li>
            <img src={jags} alt="" width="80%" />
          </li>
          <li>
            <img src={ShillsProfessional} alt="" width="80%" />
          </li>
          <li>
            <img src={Karnawat} alt="" width="80%" />
          </li>
          <li>
            <img src={Genwe} alt="" width="80%" />
          </li>
          <li>
            <img src={MissionToCure} alt="" width="80%" />
          </li>
          <li>
            <img src={MansaMataFinance} alt="" width="80%" />
          </li>
          <li>
            <img src={Veekay} alt="" width="80%" />
          </li>
          <li>
            <img src={Faatang} alt="" width="80%" />
          </li>
          <li>
            <img src={SpProduct} alt="" width="80%" />
          </li>
          <li>
            <img src={Keynote} alt="" width="100%" />
          </li>
          <li>
            <img src={Vivaah} alt="" width="80%" />
          </li>
          <li>
            <img src={Poker} alt="" width="90%" />
          </li>
          <li>
            <img src={Greenlight} alt="" width="90%" />
          </li>
          <li>
            <img src={Oleo} alt="" width="90%" />
          </li>
          <li>
            <img src={SnekaerVally} alt="" width="90%" />
          </li>

          <li>
            <img src={Terraglow} alt="" width="90%" />
          </li>
          <li>
            <img src={forumhardware} alt="" width="90%" />
          </li>
          <li>
            <img src={Snergy} alt="" width="90%" />
          </li>
          <li>
            <img src={Centerac} alt="" width="90%" />
          </li>
          <li>
            <img src={Kcl} alt="" width="90%" />
          </li>
          <li>
            <img src={Jcc} alt="" width="90%" />
          </li>

          <li>
            <img src={HelloJweller} alt="" width="90%" />
          </li>

          <li>
            <img src={Greengati} alt="" width="90%" />
          </li>
          <li>
            <img src={NeoCell} alt="" width="90%" />
          </li>

          {/* <li>
            <img src={PrimeJewller} alt="" width="90%"  />
          </li> */}
        </ul>
      </div>
    </div>
  );
}

export default Marquee;
